import { defineComponent, createElementBlock, openBlock, Fragment, renderList, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es226.js';
/* empty css                        */

const _hoisted_1 = { class: "tile-list" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Tiles",
  props: {
    tiles: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(props.tiles, (tile, index) => {
          return openBlock(), createElementBlock("li", {
            key: index,
            class: "tile-list__item"
          }, [
            createVNode(_sfc_main$1, {
              "header-icon": tile.headerIcon,
              headline: tile.headline,
              content: tile.content
            }, null, 8, ["header-icon", "headline", "content"])
          ]);
        }), 128))
      ]);
    };
  }
});

export { _sfc_main as default };
